import React, { useState } from 'react';
import {
  Typography,
  Dropdown,
  FormField,
  Container,
  Row as GridRow,
  Col,
  FlexRow,
} from 'design-system';
import { FilterIcon } from '../../../design-system/components/Icons';
import {
  MULTISELECT_LOCATION_OPTIONS,
  MULTISELECT_FILTER_GROUPS,
  USER_PICKER_OPTIONS,
  LOCATION_OPTIONS,
  DROPDOWN_RADIO_LOCATION_OPTIONS,
  ACTION_MENU_MORE_ICON,
  TILE_ACTION_MENU_OPTIONS,
  USER_PICKER_OPTIONS_FOR_SEARCH,
} from './dropdownShowcaseData';

const Separator = ({ className = '' }) => (
  <div className={['separator', className].filter(Boolean).join(' ')} />
);

export default function DropdownShowcase() {
  const [multiselectStandard, setMultiselectStandard] = useState(['alphega', 'gj', 'central']);
  const [multiselectCheckbox, setMultiselectCheckbox] = useState(['alphega', 'gj']);
  const [multiselectGroup, setMultiselectGroup] = useState(['kpi', 'chart']);
  const [multiselectSearchUsers, setMultiselectSearchUsers] = useState(['emma', 'sophie', 'michael']);
  const [selectSingleUser, setSelectSingleUser] = useState('');
  const [selectDropdownRadioLocation, setSelectDropdownRadioLocation] = useState('');
  const [tileActionMenuLast, setTileActionMenuLast] = useState('');

  return (
    <>
          {/* Dropdown Section */}
          <Col xs={12}>
            <div className="design-system-section">
              <Typography variant="h1" className="section-title mb-4">
                Dropdown Components
              </Typography>
              <Separator className="mb-5" />

              <Container className="dropdown-showcase">
                <GridRow className="mb-2">
                  <Col xs={12} md={6}>
                    <Container className="dropdown-example mb-4">
                      <Typography variant="body1" className="mb-3">
                        Single select
                      </Typography>
                      <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                        <Dropdown.Select
                          searchable
                          searchPlaceholder="Search users..."
                          placeholder="Select"
                          options={USER_PICKER_OPTIONS}
                          value={selectSingleUser}
                          onChange={setSelectSingleUser}
                        />
                      </FormField>
                    </Container>
                  </Col>
                  <Col xs={12} md={6}>
                    <Container className="dropdown-example mb-4">
                      <Typography variant="body1" className="mb-3">
                        Single select
                      </Typography>
                      <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                        <Dropdown.Select
                          searchable
                          searchPlaceholder="Search users..."
                          placeholder="Select"
                          options={LOCATION_OPTIONS}
                          value={selectSingleUser}
                          onChange={setSelectSingleUser}
                        />
                      </FormField>
                    </Container>
                  </Col>
                  <Col xs={12} md={6}>
                    <Container className="dropdown-example mb-4">
                      <Typography variant="body1" className="mb-3">
                        Multiselect (searchable)
                      </Typography>
                      <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                        <Dropdown.Multiselect
                          searchable
                          searchPlaceholder="Search users..."
                          options={USER_PICKER_OPTIONS_FOR_SEARCH}
                          value={multiselectSearchUsers}
                          onChange={setMultiselectSearchUsers}
                          showCheckboxes={false}
                          maxVisibleChips={3}
                          placeholder="Select"
                        />
                      </FormField>
                    </Container>
                  </Col>
                  <Col xs={12} md={6}>
                    <Container className="dropdown-example mb-4">
                      <Typography variant="body1" className="mb-3">
                        Single select (radio layout)
                      </Typography>
                      <FormField className="ds-form-field--width-md" label="Locations &amp; Tags" helperText="Example">
                        <Dropdown.Select
                          searchable
                          optionLayout="radio"
                          searchPlaceholder="Search location..."
                          placeholder="Select Locations &amp; Tags"
                          options={DROPDOWN_RADIO_LOCATION_OPTIONS}
                          value={selectDropdownRadioLocation}
                          onChange={setSelectDropdownRadioLocation}
                        />
                      </FormField>
                    </Container>
                  </Col>
                </GridRow>
                <Separator className="my-4" />
                <GridRow className="mb-4">
                  <Col xs={12} md={6}>
                    <Container className="dropdown-example mb-4">
                      <Typography variant="body1" className="mb-3">
                        Multiselect
                      </Typography>
                      <div style={{ maxWidth: 400 }}>
                        <Dropdown.Multiselect
                          label="Locations"
                          options={MULTISELECT_LOCATION_OPTIONS}
                          value={multiselectStandard}
                          onChange={setMultiselectStandard}
                          showCheckboxes={false}
                          maxVisibleChips={2}
                          placeholder="Select locations"
                        />
                      </div>
                    </Container>
                  </Col>
                  <Col xs={12} md={6}>
                    <Container className="dropdown-example mb-4">
                      <Typography variant="body1" className="mb-3">
                        Multiselect (checkboxes)
                      </Typography>
                      <div style={{ maxWidth: 400 }}>
                        <Dropdown.Multiselect
                          label="Locations"
                          options={MULTISELECT_LOCATION_OPTIONS}
                          value={multiselectCheckbox}
                          onChange={setMultiselectCheckbox}
                          showCheckboxes
                          maxVisibleChips={2}
                          placeholder="Select locations"
                        />
                      </div>
                    </Container>
                  </Col>
                </GridRow>
                <Separator className="my-4" />
                <GridRow className="mb-4">
                  <Col xs={12}>
                    <Container className="dropdown-example dropdown-example--action-menu-toolbar mb-4">
                      <Typography variant="body1" className="mb-3">
                        Action menu (tile edit)
                      </Typography>
                      <Typography variant="body2" color="muted" className="mb-3">
                        Toolbar pairing: filter control with <code>Dropdown.ActionMenu</code> (More).
                      </Typography>
                      <FlexRow className="dropdown-action-menu-showcase" align="center" gap={12} fullWidth>
                        <div className="dropdown-action-menu-showcase__field">
                          <Dropdown.MultiselectGroup
                            label="Filters"
                            menuIcon={<FilterIcon size={16} />}
                            groups={MULTISELECT_FILTER_GROUPS}
                            value={multiselectGroup}
                            onChange={setMultiselectGroup}
                            menuTitle="Filters"
                            clearAllLabel="Clear all"
                            showCheckboxes
                            maxVisibleChips={2}
                            placeholder="Select filters"
                          />
                        </div>
                        <Dropdown.ActionMenu
                          options={TILE_ACTION_MENU_OPTIONS}
                          onChange={setTileActionMenuLast}
                          triggerIcon={ACTION_MENU_MORE_ICON}
                          triggerAriaLabel="More options"
                          align="right"
                        />
                      </FlexRow>
                      {tileActionMenuLast ? (
                        <Typography variant="body2" color="muted" className="mt-3">
                          Last action: <code>{tileActionMenuLast}</code>
                        </Typography>
                      ) : null}
                    </Container>
                  </Col>
                </GridRow>
              </Container>
            </div>
          </Col>
    </>
  );
}